import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import path from 'path';
import { Button, Modal, Tab, Row, Col, Nav } from 'react-bootstrap';
import ScaleLoader from 'react-spinners/ScaleLoader';
import BlazeForm, { FormManager } from 'blaze-form';
import BlazeInputReactSelect from 'blaze-input-react-select';
import 'blaze-form/dist/index.css';
import 'blaze-input-react-select/dist/index.css';
import '../../styles/form/form.scss';
import toastr from '../toastr';
import PdfObject from '../PdfObject';

import browserHistory from '../../history';

import TerminalService from '../../services/TerminalService';
import { modal } from '../modal/ModalEmitter';
import LoadingPage from '../LoadingPage';
import FileNotFound from '../FileNotFound';
import FileService from '../../services/FileService';
import { layoutDispatch } from '../../services/LayoutService';
import { determineControl } from './util';
import getActions from './actions';

import FormInputCalendarItem from './control/FormInputCalendarItem';
import FormInputTagsItem from './control/FormInputTagsItem';
import FormInputUpload from './control/FormInputUpload';
import FormInputColorPicker from './control/FormInputColorPicker';

import FormInputAccountSearch from './control/FormInputAccountSearch';
import FormInputListSearch from './control/FormInputListSearch';
import FormInputCustomerSearch from './control/FormInputCustomerSearch';
import FormInputCustomerVehicleSearch from './control/FormInputCustomerVehicleSearch';
import FormInputDbSearch from './control/FormInputDbSearch';
import FormInputRepairSearch from './control/FormInputRepairSearch';
import FormInputSimpleSearch from './control/FormInputSimpleSearch';
import FormInputStaticSearch from './control/FormInputStaticSearch';
import FormInputVehicleSearch from './control/FormInputVehicleSearch';
import FormInputVehicleSaleSearch from './control/FormInputVehicleSaleSearch';
import FormInputVendorSearch from './control/FormInputVendorSearch';
import FormInputZipcodeSearch from './control/FormInputZipcodeSearch';
import FormInputPageSearch from './control/FormInputPageSearch';
import FormInputRuntimeDate from './control/FormInputRuntimeDate';
import FormInputMultiListSearch from './control/FormInputMultiListSearch';
import FormInputDbSelect from './control/FormInputDbSelect';
import FormInputLoyaltyCustomer from './control/FormInputLoyaltyCustomer';

import FormInputTagsAccountSearch from './control/FormInputTagsAccountSearch';
import FormInputTagsCustomerSearch from './control/FormInputTagsCustomerSearch';
import FormInputTagsDbSearch from './control/FormInputTagsDbSearch';
import FormInputTagsListSearch from './control/FormInputTagsListSearch';
import FormInputTagsPageSearch from './control/FormInputTagsPageSearch';
import FormInputTagsRepairSearch from './control/FormInputTagsRepairSearch';
import FormInputTagsStaticSearch from './control/FormInputTagsStaticSearch';
import FormInputTagsVehicleSearch from './control/FormInputTagsVehicleSearch';
import FormInputTagsVehicleSaleSearch from './control/FormInputTagsVehicleSaleSearch';
import FormInputTagsVendorSearch from './control/FormInputTagsVendorSearch';
import FormInputTagsMultiListSearch from './control/FormInputTagsMultiListSearch';
import FormInputMarkdown from './control/FormInputMarkdown';
import FormInputQuoteFlow from '../crm/FormInputQuoteFlow';
import FormInputLinkOrder from '../crm/FormInputLinkOrder';
import FormMultiUnitSelection from '../crm/FormMultiUnitSelection';
import FormInputVehicleSelection from '../crm/FormInputVehicleSelection';
import FormInputCustomerSaleSelection from '../crm/FormInputCustomerSaleSelection';

import FormHelperBarcodeScanner from './helpers/FormHelperBarcodeScanner';
import FormHelperDefault from './helpers/FormHelperDefault';
import FormTableFilter from './table/FormTableFilter';
import WarningList from './misc/WarningList';
import ValidationReport from './misc/ValidationReport';
import UnsavedReport from './misc/UnsavedReport';

// TODO Remove submitCallback prop
// TODO minimize need for FEC ref
// TODO refactor submit prop

// non-breaking space
import { LIST_ITEM_DELIMITER } from '../../util/form';

const controls = {
  // Input: FormInputItem,
  // Select: FormInputSelectItem,
  // Textarea: FormInputTextareaItem,
  // Button: FormInputButton,
  // Paragraph: FormParagraph,
  // Checkbox: FormInputCheckbox,
  Upload: FormInputUpload,
  Calendar: FormInputCalendarItem,
  ColorPicker: FormInputColorPicker,
  Markdown: FormInputMarkdown,

  QuoteFlow: FormInputQuoteFlow,
  LinkOrder: FormInputLinkOrder,
  MultiUnitSelection: FormMultiUnitSelection,
  VehicleSaleSelection: FormInputVehicleSelection,
  CustomerSaleSelection: FormInputCustomerSaleSelection,

  Search: FormInputListSearch, // default search
  AccountSearch: FormInputAccountSearch,
  ListSearch: FormInputListSearch,
  CustomerSearch: FormInputCustomerSearch,
  CustomerVehicleSearch: FormInputCustomerVehicleSearch,
  DbSearch: FormInputDbSearch,
  DbSelect: FormInputDbSelect,
  RepairSearch: FormInputRepairSearch,
  SimpleSearch: FormInputSimpleSearch,
  StaticSearch: FormInputStaticSearch,
  VehicleSearch: FormInputVehicleSearch,
  VehicleSaleSearch: FormInputVehicleSaleSearch,
  VendorSearch: FormInputVendorSearch,
  ZipcodeSearch: FormInputZipcodeSearch,
  PageSearch: FormInputPageSearch,
  RuntimeDate: FormInputRuntimeDate,
  MultiListSearch: FormInputMultiListSearch,
  LoyaltyCustomer: FormInputLoyaltyCustomer,

  Tags: FormInputTagsItem,
  TagsAccountSearch: FormInputTagsAccountSearch,
  TagsCustomerSearch: FormInputTagsCustomerSearch,
  TagsDbSearch: FormInputTagsDbSearch,
  TagsListSearch: FormInputTagsListSearch,
  TagsPageSearch: FormInputTagsPageSearch,
  TagsRepairSearch: FormInputTagsRepairSearch,
  TagsStaticSearch: FormInputTagsStaticSearch,
  TagsVehicleSearch: FormInputTagsVehicleSearch,
  TagsVehicleSaleSearch: FormInputTagsVehicleSaleSearch,
  TagsVendorSearch: FormInputTagsVendorSearch,
  TagsMultiListSearch: FormInputTagsMultiListSearch,
  ReactSelect: BlazeInputReactSelect,
};

const helpers = {
  barcodescanner: FormHelperBarcodeScanner,
  default: FormHelperDefault, // default is used if helper name doesn't match others
};

// encoder / decoder used to have a display value with the proper value present and extractable
// example: "1234<LIST_ITEM_DELIMITER>Human Friendly Value"
export const valueDecoder = value => {
  const regex = new RegExp(`^(.*):${LIST_ITEM_DELIMITER}`, 'u');
  const matches = value.match(regex);
  if (matches) {
    return matches[1];
  }

  return value;
};

export const valueEncoder = ({ data, dataAlt }) => {
  if (!dataAlt) {
    return data;
  }

  return `${data}:${LIST_ITEM_DELIMITER}${dataAlt}`;
};

// Focus on a textarea or button will required a 'TAB' still
const legacyEvent = event => {
  if (event.keyCode === 13 && (event.target.nodeName === 'INPUT' || event.target.nodeName === 'SELECT')) {
    const form = event.target.form;
    if (form) {
      const index = Array.prototype.indexOf.call(form, event.target);
      if (index && form.elements[index + 1]) {
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    }
  }
};

export const FormContainerContext = React.createContext({});

class Form extends Component {
  constructor(props) {
    super(props);

    this.manager = new FormManager();
    for (const name of Object.keys(controls)) {
      this.manager.registerControl({ name, component: controls[name] });
    }

    for (const name of Object.keys(helpers)) {
      this.manager.registerToolbarHelper({ name, component: helpers[name] });
    }

    this.manager.valueDecoder = valueDecoder;
    this.manager.valueEncoder = valueEncoder;
    this.manager.setPredefined({ user: props.user, features: props.features, branch: props.branch });
    this.manager.features = props.features || {};
    this.manager.determineControl = determineControl.bind(this.manager);

    this.state = {
      process: { show: false, success: null },
    };

    this.fec = React.createRef();
    this.manager.formHandler = this.fec;
    this.contextValue = { branchId: props.branchId };
  }

  componentDidMount() {
    if (this.props.useEnterTab) {
      document.addEventListener('keydown', legacyEvent, true);
    }
  }

  componentWillUnmount() {
    if (this.props.useEnterTab) {
      document.removeEventListener('keydown', legacyEvent, true);
    }
  }

  getPopulatedMethod(method = {}, fieldName, dataIndex) {
    const form = this.manager.getData();

    // Inject common data into rule definition
    if (fieldName) {
      method.data = dataIndex !== undefined ? form[fieldName].data[dataIndex] : form[fieldName].data;

      // TODO run data through a more general sanitizer perhaps?
      if (form[fieldName].type === 'currency' && method.data && method.data.replace) {
        method.data = method.data.replace(/[$,]/g, '');
      }
    }

    method.pageName = this.props.itemName;

    // Update any method keys to use current form data
    // Don't mutate rule.method.keys as it might need to re-run
    let keyData = [];
    if (method.keys) {
      method.keys.forEach(key => {
        let data = key;

        // Key matches field name, so use field value instead of literal
        if (form[key]) {
          if (form[key].collection && dataIndex !== undefined) {
            data = form[key].data[dataIndex];
          } else {
            data = form[key].data;
          }
        }

        keyData.push(data);
      });
    }

    if (method.allKeys) {
      keyData = this.manager.exportData();
    }

    method.keyData = keyData;

    if (dataIndex !== undefined) {
      method.rowIndex = dataIndex + 1;
    }

    return method;
  }

  handleUpdateRule = ({ rule, fieldName, dataIndex, rowId, reRenderForm }) => {
    const fec = this.fec.current;
    const method = this.getPopulatedMethod(rule.method, fieldName, dataIndex);

    // Disable Submit
    if (fec && fec.toggleControls) {
      fec.toggleControls(false);
    }

    layoutDispatch(method)
      .then(response => {
        const result = response.data.data;

        if (typeof result !== 'object') {
          console.warn('Invalid response for blur event:', response);
          return;
        }

        if (this.handleFileInResponse(response.data)) {
          return;
        }

        if (this.handleSpecialResponse(response.data)) {
          return;
        }

        // Replace any keys in response data
        if (fec && fec.updateForm) {
          fec.updateForm(result, dataIndex, rowId, reRenderForm);
        }
      })
      .catch(err => {
        if (err.response && this.handleLowLevelValidation(err.response.data)) {
          fec.incrementKey();
        } else {
          throw err;
        }
      })
      .finally(() => {
        if (fec && fec.toggleControls) {
          fec.toggleControls(true);
        }
      });
  };

  updateForm = (...args) => {
    if (!this.fec || !this.fec.current) {
      return;
    }

    this.fec.current.updateForm(...args);
  };

  handleValidationReport = ({ report, form, highlight }) => {
    modal.open('report', {
      style: 'center',
      render: 'report',
      headerClass: 'primary',
      title: 'Validation Report',
      message: <ValidationReport form={form} highlight={highlight} report={report} />,
    });
  };

  handleUnsavedReport = () => {
    modal.open('unsaved', {
      style: 'center',
      size: 'md',
      title: 'Unsaved Changes',
      hidePrint: true,
      message: <UnsavedReport manager={this.manager} />,
    });
  };

  handleLaunch = ({ helper, data, rowId, dataIndex, ...options }) => {
    if (helper instanceof Function) {
      helper({ formHandler: this.fec.current, data, rowId, dataIndex });
      return;
    }

    switch (helper) {
      case 'terminal':
        TerminalService.open(data);
        break;
      case 'browser':
        window.open(data, '_blank');
        break;
      default:
        modal.open(helper, { ...options, lookupKey: data, rowId, dataIndex, fec: this.fec.current });
    }
  };

  handleCancel = () => {
    if (this.props.useDirtyWarning && this.manager.isDirty()) {
      modal.confirm({
        title: 'Wait',
        message: 'It appears there are unsaved changes.  Are you sure you want to cancel?',
        confirmLabels: ['Yes', 'No'],
        callback: () => {
          this.props.onCancel();
        },
      });
    } else {
      this.props.onCancel();
    }
  };

  handleBeforeSubmit = ({ currentStep }) => {
    const { confirmSubmit } = this.props;
    const { layout } = this.manager;
    const fec = this.fec.current;
    const warnings = this.manager.getWarnings();

    if (fec && !fec.state.enabledControls) {
      toastr.warn('Busy', 'The form is not ready to be submitted');
      return false;
    }

    if (warnings.length) {
      return new Promise(resolve => {
        modal.open('warninglist', {
          hidePrint: true,
          render: 'warninglist',
          style: 'center',
          title: 'Warning',
          size: 'md',
          confirm: true,
          confirmLabels: ['Confirm Submission', 'Cancel'],
          callback: () => resolve(true),
          onClose: () => resolve(false),
          message: <WarningList warnings={warnings} />,
        });
      });
    }

    if (confirmSubmit) {
      // Only confirm on last step when steps are used
      if (layout.hasSteps) {
        const isLast = layout.getSteps().length === currentStep + 1;
        if (!isLast) {
          return true;
        }
      }

      return new Promise(resolve => {
        modal.confirm({
          title: 'Confirm',
          message: 'Are you sure you want to submit?',
          confirmLabels: ['Yes', 'No'],
          onClose: () => resolve(false),
          callback: () => resolve(true),
        });
      });
    }

    return true;
  };

  handleSubmit = (data, { form, currentStep }) => {
    const { legacyFormat } = this.props;
    const { layout } = this.manager;
    const fec = this.fec.current;
    const changes = [];

    // Export format is an array
    if (Array.isArray(data)) {
      data.forEach(d => {
        if (form[d.name]?.dirty === true) {
          changes.push(d.name);
        }
      });
    }

    if (legacyFormat) {
      // Convert all data to strings
      data.forEach(field => {
        if (form[field.name].type !== 'file') {
          if (Array.isArray(field.data)) {
            field.data.forEach((value, index) => {
              // Tags in a table
              if (Array.isArray(value)) {
                value.forEach((v, i) => {
                  value[i] = String(v);
                });
              } else {
                field.data[index] = String(value);
              }
            });
          } else {
            field.data = String(field.data);
          }
        }
      });
    }

    if (layout.hasSteps) {
      data.push({
        collection: false,
        name: 'currentStep',
        data: currentStep + 1,
        final: layout.getSteps().length === currentStep + 1,
      });
    }

    const result = this.props.submit(data);

    if (!result || !result.then) {
      return Promise.resolve();
    }

    return result
      .then(response => {
        fec.submitted = false;
        const responsePayload = _.get(response, 'payload', response || {});
        const message = _.get(responsePayload, 'data.responses[0].message') || 'Action successful';

        // Response has entirely new layout
        if (this.isNewLayout(responsePayload)) {
          fec.initLayout(responsePayload.data.page_layout, true);
          fec.forceUpdate();
          return Promise.resolve({ message, response: responsePayload });
        }

        // TODO Dislike the responses array for everything rather have an object:
        // { file: {}, message: '', errors: [] }
        this.handleFileInResponse(responsePayload);
        this.handleSpecialResponse(responsePayload);

        // Using layout steps
        if (fec.layout.hasSteps && (fec.layout.getSteps()[currentStep + 1] || _.get(responsePayload, 'data.useStep'))) {
          fec.nextStep(responsePayload.data);
          return Promise.resolve({ message, response: responsePayload });
        }

        this.showFeedback(message, { title: 'Saved' });

        this.props.submitCallback(responsePayload, { data, manager: this.manager, changes });

        fec.submitted = true;
        return Promise.resolve({ message, response: responsePayload });
      })
      .catch(err => {
        const { response } = err;

        // assuming regular error without a response
        if (!response) {
          this.showFeedback(err.message, { type: 'error' });
          return Promise.reject(err);
        }

        const responsePayload = _.get(response, 'payload', response || {});
        if (this.handleLowLevelValidation(responsePayload)) {
          fec.incrementKey({ form });

          // TODO close button steals focus which causes form to revalidate
          // this.showFeedback('Validation Failed', { type: 'error' });
          return Promise.reject(err);
        }

        this.showFeedback(_.get(responsePayload, 'data.error', 'Application Error'), { type: 'error' });
        return Promise.reject(err);
      });
  };

  /**
   * Any backend validation failures are handled here.
   *
   * @param {Object} response - Response object with validation information.
   * @return {Boolean} - Success or failure with low level validation.
   */
  handleLowLevelValidation(response = {}) {
    console.debug('handleLowLevelValidation', response);
    const fec = this.fec.current;
    const form = this.manager.getData();

    // TODO: The proper error code here is 400 for Bad Request
    const status = _.get(response, 'data.status');
    if (!/^[4-5]\d\d$/.test(status)) {
      console.warn('Not an error status code', status);
      return false;
    }

    const responses = _.get(response, 'data.responses');
    if (!responses) {
      console.warn('Encountered a low level validation problem with no responses', response);
      return false;
    }

    let success = true;
    responses.forEach(error => {
      let fieldName = error.name;

      if (!fieldName || !form[fieldName]) {
        FormManager.warnFieldName(fieldName);
        return;
      }

      // Problem with itemid on an edit (usually stale data)
      if (!fec.isCreationAction() && error.name === 'itemid') {
        success = false;
        modal.alert({ title: 'Submission Problem', message: error.error });
      }

      // Field names in the result might have the new itemid in them but they are not
      // named as such on the form.  Consider this a patch for unusual behavior with
      // legacy forms. (*S.TABLE<newlyEnteredItemId>_2 -> *S.TABLE<currentId>_2) Issue#36
      if (fec.isCreationAction()) {
        const itemId = responses[responses.length - 1].itemid;
        const regex = new RegExp(`${itemId}_`, 'g');
        fieldName = fieldName.replace(regex, `${fec.state.itemId.data}_`);
      }

      this.manager.setInvalid(fieldName, error.error, error.row);
      fec.reportAddendum[fieldName] = error.error;
    });

    fec.syncForm();
    return success;
  }

  handleFileInResponse(response = {}) {
    let fileInResponse = _.get(response, 'data.responses[0].file');
    if (fileInResponse) {
      if (!Array.isArray(fileInResponse)) {
        fileInResponse = [fileInResponse];
      }

      const filesToShow = [];
      const filesToDownload = [];
      fileInResponse.forEach(file => {
        if (!_.isObject(file)) {
          console.warn('Invalid file response, expected Object', fileInResponse);
          return;
        }

        if (path.extname(file.filename).substring(1).toLowerCase() === 'pdf') {
          filesToShow.push({
            url: /^https?:\/\//.test(file.source) ? file.source : FileService.downloadPath(file.filename, file.source),
            title: file.filename,
          });
        } else {
          filesToDownload.push({
            url: /^https?:\/\//.test(file.source) ? file.source : FileService.downloadPath(file.filename, file.source),
            title: file.filename,
          });
        }
      });

      if (filesToShow.length) {
        modal.open({
          title: 'Print Documents',
          size: 'lg',
          hidePrint: true,
          hideFooter: true,
          staticBackdrop: true,
          headerClass: 'default',
          message: (
            <Tab.Container id="left-tabs" defaultActiveKey="evt0">
              <Row className="clearfix">
                <Col sm={3}>
                  <Nav variant="pills" className="flex-column">
                    {filesToShow.map((doc, index) => (
                      <Nav.Item key={index}>
                        <Nav.Link eventKey={`evt${index}`}>{doc.title}</Nav.Link>
                      </Nav.Item>
                    ))}
                  </Nav>
                </Col>
                <Col sm={9}>
                  <Tab.Content>
                    {filesToShow.map((doc, index) => (
                      <Tab.Pane key={index} eventKey={`evt${index}`}>
                        <PdfObject url={doc.url} width="100%" height="800" />
                      </Tab.Pane>
                    ))}
                  </Tab.Content>
                </Col>
              </Row>
            </Tab.Container>
          ),
        });
      }

      if (filesToDownload.length) {
        filesToDownload.forEach(file => {
          FileService.downloadDataUri(file.url, file.title);
        });
      }

      return true;
    }

    return false;
  }

  handleSpecialResponse(response = {}) {
    if (!_.isPlainObject(response)) {
      return false;
    }

    const redirect = _.get(response, 'data.redirect');

    if (redirect) {
      if (browserHistory.location.pathname === redirect) {
        browserHistory.push(`${redirect}/refresh`);
        setTimeout(() => {
          browserHistory.replace(redirect);
        });
      } else {
        browserHistory.push(redirect);
      }
      return true;
    }

    return false;
  }

  handleTableFilter = ({ title, form }) => {
    const modalTitle = title ? `Filter ${title}` : 'Filter';

    return new Promise(resolve => {
      modal.open('filter', {
        headerClass: 'primary',
        hideFooter: true,
        hidePrint: true,
        style: 'center',
        title: modalTitle,
        message: <FormTableFilter collection={form} handleApply={resolve} />,
        onClose: () => resolve(), // make sure to resolve nothing on close
      });
    });
  };

  /**
   * Analyzes a response to determine if a new layout is defined.
   *
   * @param {Object} response - response object.
   * @return {Boolean}
   */
  isNewLayout(response = {}) {
    return (
      _.get(response, 'data.page_layout') &&
      Array.isArray(response.data.page_layout) &&
      response.data.page_layout.length
    );
  }

  /**
   * Displays a message to the user either in toastr or modal form
   *
   * @param {String} message - Message to be displayed in feedback.
   * @param {Object} options - Feedback options.
   * @return {Boolean}
   */
  showFeedback(message = '', options = {}) {
    const { feedback } = this.props;
    // Url is the message
    if (/^https?:\/\//.test(message)) {
      window.open(message, '_blank');
      return true;
    }

    // No feedback when set to none
    if (feedback === 'none') {
      return true;
    }

    if (feedback === 'erroronly' && options.type !== 'error') {
      return true;
    }

    // Set some defaults
    options.type = options.type || 'success';
    if (!options.title && options.type === 'error') {
      options.title = 'Oops!';
    }

    if (feedback === 'modal') {
      // TODO use ModalConductor instead of process state!
      const success = options.type !== 'error';
      this.setState({ process: { success, message, show: true } });
      return true;
    }

    const timeOut = message && message.length > 50 ? 8000 : 4000;

    toastr[options.type](options.title, message, { timeOut });
    return true;
  }

  dismissProcess = () => {
    this.setState({ process: { ...this.state.process, show: false } });
  };

  renderModalMessage() {
    const { process, saving } = this.state;
    let message = "Your request has been queued.  As this may take some time you're free to dismiss this window.";
    if (!saving) {
      message = 'Your request has completed';
      if (process && process.message) {
        message = process.message;
      }
    }

    return message;
  }

  /**
   * Determines the status icon for the process modal.
   *
   * @return
   */
  renderStatusIcon() {
    const { process, saving } = this.state;
    if (saving) {
      return <ScaleLoader color="#CCCCCC" />;
    }

    if (process && process.success === false) {
      return <i className="zmdi zmdi-alert-circle zmdi-hc-4x failure" />;
    }

    return <i className="zmdi zmdi-check-circle zmdi-hc-4x success" />;
  }

  /**
   * Modal wrapper for process modal.
   *
   * @return {Object} - JSX.
   */
  renderProcessModal() {
    const { process } = this.state;
    return (
      <Modal
        show={process.show}
        aria-labelledby="contained-modal-title-sm"
        onHide={this.dismissProcess}
        id="process-modal"
      >
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="status-icon">{this.renderStatusIcon()}</div>
          <p className="modal-body-text">{this.renderModalMessage()}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.dismissProcess} variant="secondary">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  renderInvalidLayout = () => {
    return <FileNotFound message="Oops... page layout is invalid or empty" />;
  };

  renderLoading = () => {
    return <LoadingPage />;
  };

  render() {
    const { user, features, forwardedRef, page, usePrefix, hideToolbar, globalShowHelp, showHelp, ...rest } =
      this.props;
    const pageProps = page.Form || {};
    const options = page.options || {};

    if (usePrefix === 'modal') {
      options.verticalTabs = false;
    }

    const customActions = this.props.customActions || getActions(rest.itemName, rest);

    if (user.username === 'dsisupport') {
      customActions.push({
        key: 'unsaved',
        id: 'unsaved',
        label: <i className="fas fa-wave-sine fa-fw" />,
        side: 'right',
        className: 'icon-only',
        title: 'Unsaved Changes',
        action: this.handleUnsavedReport,
      });
    }

    return (
      <FormContainerContext.Provider value={{ ...this.contextValue }}>
        {this.renderProcessModal()}
        <BlazeForm
          {...rest}
          {...pageProps}
          showHelp={showHelp !== undefined ? showHelp : globalShowHelp}
          customActions={customActions}
          ref={this.fec}
          onBeforeSubmit={this.handleBeforeSubmit}
          onCancel={this.handleCancel}
          onLaunch={this.handleLaunch}
          onSubmit={this.handleSubmit}
          onTableFilter={this.handleTableFilter}
          onValidationReport={this.handleValidationReport}
          onUpdateRule={this.handleUpdateRule}
          manager={this.manager}
          renderInvalidLayout={this.renderInvalidLayout}
          options={options}
          hideToolbar={page.hideToolbar || hideToolbar}
          usePrefix={usePrefix}
          useTypedData={false}
        />
      </FormContainerContext.Provider>
    );
  }
}

Form.defaultProps = {
  confirmSubmit: false,
  exportFormat: 'array',
  feedback: 'toaster',
  focusFirstField: true,
  legacyFormat: false,
  onCancel: () => browserHistory.push('/'),
  page: {},
  globalShowHelp: false,
  submit: () => {},
  submitCallback: () => {},
  useDirtyWarning: true,
  useEnterTab: false,
  useTypedData: false,
  initialValues: {},
};

Form.propTypes = {
  branchId: PropTypes.string,
  confirmSubmit: PropTypes.bool,
  customActions: PropTypes.array,
  exportFormat: PropTypes.string,
  feedback: PropTypes.oneOf(['toaster', 'modal', 'erroronly', 'none']),
  focusFirstField: PropTypes.bool,
  forwardedRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  globalShowHelp: PropTypes.bool,
  hideCancel: PropTypes.bool,
  hideToolbar: PropTypes.bool,
  itemName: PropTypes.string,
  layout: PropTypes.array,
  legacyFormat: PropTypes.bool,
  onCancel: PropTypes.func,
  onChange: PropTypes.func,
  page: PropTypes.object,
  ref: PropTypes.any,
  resetOnSubmit: PropTypes.bool,
  showHelp: PropTypes.bool,
  submit: PropTypes.func,
  submitAll: PropTypes.bool,
  submitCallback: PropTypes.func,
  submitLabel: PropTypes.any,
  trackDirty: PropTypes.bool,
  useDirtyWarning: PropTypes.bool,
  useEnterTab: PropTypes.bool,
  useTypedData: PropTypes.bool,
  usePrefix: PropTypes.string,
  initialValues: PropTypes.object,

  // Redux props
  user: PropTypes.object,
  features: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    branch: state.app.branch,
    features: state.app.config.features,
    globalShowHelp: state.app.showHelp, // allow local prop to override store value
    user: state.app.user,
  };
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(Form);
